import { createElement, findElement, selectedElementAll } from "../utils/element-handlers.utils";

function CardRestrictComponent(cardRestrictElement: HTMLElement) {
    const infoContentElement = findElement('.n-card-info-content', cardRestrictElement);
    const formatElement = findElement('.n-format', cardRestrictElement);

    if (infoContentElement && formatElement) {
        const originalHTMLText = formatElement.innerHTML;
        // const truncatedHTMLText = originalHTMLText.substring(0, 200) + '...';

        if (originalHTMLText.length > 600) {
            let firstElement:HTMLElement | null = formatElement.children[0] as HTMLElement || null; 
            const hiddenElements: HTMLElement[] = [];
            const dots = createElement('span', null, ' ...');

            Array.from(formatElement.children).forEach((childElement, index) => {
                if (index > 0) {
                    (childElement as HTMLElement).style.display = 'none';
                    hiddenElements.push(childElement as HTMLElement);
                }
            });

            
            firstElement && firstElement.appendChild(dots);
            // formatElement.innerHTML = truncatedHTMLText;

            let cardActionsElement: HTMLElement;
            infoContentElement.insertAdjacentElement('afterend', cardActionsElement = createElement('div', 'n-card-info-actions', [
                createElement('button', {
                    className: 'n-button n-outline'
                }, 'More', {
                    click: event => {
                        event.preventDefault();
                        // formatElement.innerHTML = originalHTMLText;
                        hiddenElements.forEach(hiddenElement => hiddenElement.removeAttribute('style'));
                        dots.remove();
                        cardActionsElement.remove();
                    }
                })
            ]));
        }
    }
}

export default function initCardRestrictComponent() {
    selectedElementAll('.n-card-restrict', CardRestrictComponent);
}
